import axios from './axios';

const TodoService = {
  getTodos: () => axios.get('/api/v1/todos'),
  getTodo: (id) => axios.get(`/api/v1/todos/${id}`),
  createTodo: (data) => axios.post('/api/v1/todos', data),
  updateTodo: (id, data) => axios.put(`/api/v1/todos/${id}`, data),
  deleteTodo: (id) => axios.delete(`/api/v1/todos/${id}`),
};

export default TodoService;
